<template>
  <div>
    <Header />
    <div class="contact-main-container">
      <div class="container">
        <div class="contact-title-header">
          <div class="contact-title">Contact Us</div>
          <div class="contact-back-btn">
            <router-link to="/"> Home </router-link>
          </div>
        </div>
        <div class="contact-body">
          <div class="row">
            <div class="col-lg-6 contact-body-form">
              <h4>Inquriy Form</h4>
              <hr />
              <div class="form-group contact-form">
                <label for="text">Name :</label>
                <input
                  v-model="enq_name"
                  type="text"
                  class="form-control"
                  id="name"
                  placeholder="Enter Name"
                  name="name"
                  required
                />
              </div>
              <div class="form-group contact-form">
                <label for="text">Address :</label>
                <input
                  v-model="enq_address"
                  type="text"
                  class="form-control"
                  id="mobile"
                  placeholder="Enter Address Numbar"
                  name="text"
                  required
                />
              </div>
              <div class="form-group contact-form">
                <label for="text">Mobile :</label>
                <input
                  v-model="enq_phone"
                  type="text"
                  class="form-control"
                  id="mobile"
                  placeholder="Enter Mobile Numbar"
                  name="mobile"
                  required
                />
              </div>
              <div class="form-group contact-form">
                <label for="text">Email :</label>
                <input
                  v-model="enq_email_address"
                  type="text"
                  class="form-control"
                  id="email"
                  placeholder="Enter Email Address"
                  name="email"
                  required
                />
              </div>
              <div class="form-group contact-form">
                <label for="msg">Message:</label>
                <textarea
                  v-model="enq_message"
                  class="form-control"
                  rows="5"
                  id="msg"
                  placeholder="Enter Message"
                  name="msg"
                  required
                ></textarea>
              </div>
              <button @click="sendMail()" class="contactformsubmit">
                Submit
              </button>
            </div>
            <div class="col-lg-6 contact-body-address">
              <h4>Address</h4>
              <hr />
              <div class="address-grid-x">
                <p><i class="fa fa-map-marker"></i></p>
                <p>{{ address }}</p>
              </div>
              <div class="address-grid-x">
                <p><i class="fa fa-phone"></i></p>
                <p>{{ contact_no }}</p>
              </div>
              <div class="map-location">
                <iframe
                  :src="mapapi"
                  width="100%"
                  height="400"
                  frameborder="0"
                  style="border: 0"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
    <Footer />
  </div>
</template>


<script>
import Header from "./Header";
import Footer from "./Footer";

import { mapGetters, mapActions } from "vuex";

import $ from "jquery";

export default {
  name: "Contact",
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      address: "",
      contact_no: "",
      geo_latitude: "",
      geo_longitude: "",
      mapapi: "",
      userinfo: localStorage.getItem("userinfo")
        ? JSON.parse(localStorage.getItem("userinfo"))
        : [],
      enq_name: "",
      enq_address: "",
      enq_phone: "",
      enq_message: "",
      enq_email_address: "",
    };
  },
  computed: {
    ...mapGetters(["outletInformation"]),
  },
  methods: {
    ...mapActions(["getMenuItems"]),

    sendMail() {
      var val = this.enq_phone;
      if (/^\d{10}$/.test(val)) {
        // value is ok, use it
        // alert("Valid")
      } else {
        // alert("Invalid number; must be ten digits")

        this.$bvToast.toast(
          "Invalid mobile number. Please enter valid number",
          {
            variant: "danger",
            toaster: "b-toaster-bottom-left",
            solid: true,
          }
        );

        return;
      }

      if (this.enq_name == "" || this.enq_name == undefined) {
        this.$bvToast.toast("Please enter name", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.enq_address == "" || this.enq_address == undefined) {
        this.$bvToast.toast("Please enter address", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      if (this.enq_message == "" || this.enq_message == undefined) {
        this.$bvToast.toast("Please enter message", {
          variant: "danger",
          toaster: "b-toaster-bottom-left",
          solid: true,
        });

        return;
      }

      let currentObj = this;

      const mail_data = {
        subject: `Digital Menu Query : ${this.enq_name} (${this.enq_phone})`,
        to: "Email",
        text: this.enq_message,
      };

      currentObj.axios
        .post("sendmail", mail_data)
        .then(function (response) {
          console.log("sendmail " + JSON.stringify(response));

          currentObj.sendEnquiry();
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendEnquiry() {
      let currentObj = this;

      let store_id = "";
      let tmpos_id = "";
      let source =""
      // source = 'food2all_website'
      // source = 'ariose_website'
      // source = "grillfry_website";
      // source = 'bowlsnboxes_website'
      // source = 'beintehaanbiryani_website'
      // source = "broasted_website";
      // source = "swadisht_website";
      // source = "mughliazz_website";
     // source="puchkawala"; //puchkawala
     source="kurryKingdom_website"; //puchkawala

      //To check enquiry from which source
      ////let source = "mahamangal_website";

      currentObj.outletInformation.forEach((item) => {
        // alert("Store id is " + item.store_id)
        // alert("tmpos id is " + item.tmpos_id)

        store_id = item.store_id;
        tmpos_id = item.tmpos_id;
      });

      const enq_data = {
        first_name: this.enq_name,
        phone: this.enq_phone,
        address: this.enq_address,
        message: this.enq_message,
        store_id: store_id,
        tmpos_id: tmpos_id,
        type: "query",
        source: source,
        email: this.enq_email_address,
      };

      currentObj.axios
        .post("enquiry", enq_data)
        .then(function (response) {
          // console.log("enquiry "+JSON.stringify(response))
          let status = JSON.stringify(response.data.status);

          if (status == 200) {
            currentObj.enq_name = "";
            currentObj.enq_address = "";
            currentObj.enq_phone = "";
            currentObj.enq_message = "";

            currentObj.$bvToast.toast(`Your enquiry sent successfully`, {
              variant: "success",
              toaster: "b-toaster-bottom-left",
              solid: true,
            });
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  created() {
    this.getMenuItems();

    this.outletInformation.forEach((item) => {
      this.address = item.address;
      this.contact_no = item.contact_phone;
      this.geo_latitude = item.geo_latitude;
      this.geo_longitude = item.geo_longitude;
      //alert(JSON.stringify(item.geo_latitude))
    });

    this.enq_name = this.userinfo ? this.userinfo.name : "";
    this.enq_phone = this.userinfo ? this.userinfo.phone : "";
    this.enq_address = this.userinfo ? this.userinfo.address_line1 : "";
    this.enq_email_address = this.userinfo ? this.userinfo.email : "";

    //   this.mapapi = "https://www.google.com/maps/embed/v1/place?q="+this.geo_latitude+","+this.geo_longitude+"&key=AIzaSyAI8Rw6GubVmklVABUiHqwq1XqCwPxiAVg"

    this.mapapi =
      "https://maps.google.com/maps?q=" +
      this.geo_latitude +
      "," +
      this.geo_longitude +
      "&z=15&output=embed";
    // alert(this.mapapi)

    this.$nextTick(function () {
      // $("#divTest").scrollTop($("#divTest")[0].scrollHeight);

      $(window).scrollTop(0);
    });
  },
};
</script>